import React from "react";
import bgimage from "../../../assets/img/img/teamanics_logo.svg";

const ClientNavBar = () => {
  return (
    <>
      <header className="bg-gradient-to-br from-primary-blue3 to-primary-blue min-sm:fixed top-0 w-screen max-sm:h-1/2 max-sm:-z-10 min-sm:h-16 shadow-primary-gray head_nav_z"></header>
      <div className=" min-sm:ml-9 w-32 top-[24px]  fixed max-sm:absolute z-30 max-sm:ml-6"></div>

      <nav className="navbar fixed-top bg-gradient-to-br from-primary-blue3 to-primary-blue min-sm:fixed top-0 w-screen max-sm:h-1/2 max-sm:-z-10 min-sm:z-0 min-sm:h-16 shadow-primary-gray head_nav_z">
        <a className="menu-button d-md-block ml-3">
          <img alt="hero" src={bgimage} />
        </a>

        <div className="navbar-right">
          <div className="user d-inline-block">
            <div className="dropdown-menu-right dropdown show">
              <button
                type="button"
                aria-haspopup="true"
                aria-expanded="true"
                className="p-0 btn btn-empty"
              ></button>
            </div>
          </div>

          <div className="dropdown-menu-right dropdown">
            <div
              tabIndex="-1"
              role="menu"
              aria-hidden="true"
              className="mt-3 dropdown-menu dropdown-menu-right"
            ></div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default ClientNavBar;
